import { APIRoute } from '@/modules/utils'
import { Picture } from '@/dataV3/Common/Picture'

export const Route: APIRoute = {
  method: 'POST',
  path: '/members/pictures',
}

export type Body = {
  base64: string
  isMain: boolean
}

export type Response = Picture
